export const defaultLayout = (LayoutAccountID) => ({
    "LayoutID": 1,
    "LayoutName": "Default Layout",
    "LayoutStatusID": 1,
    "LayoutAccountID": LayoutAccountID,
    "LayoutStatusName": "Enable",
    "LayoutParametersList": [
        {
            "JPath": "$ShowWidgetTitles",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 1,
            "ParameterTypeName": "Boolean",
            "LayoutParameterName": "ShowWidgetTitles",
            "LayoutParameterValueID": 603
        },
        {
            "JPath": "$FontSize",
            "Value": "16",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 2,
            "ParameterTypeName": "Number",
            "LayoutParameterName": "FontSize",
            "LayoutParameterValueID": 604
        },
        {
            "JPath": "$WidgetTitlesFontSize",
            "Value": "22",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 3,
            "ParameterTypeName": "Number",
            "LayoutParameterName": "WidgetTitlesFontSize",
            "LayoutParameterValueID": 605
        },
        {
            "JPath": "$WidgetGroupTitlesFontSize",
            "Value": "48",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 20,
            "ParameterTypeName": "Number",
            "LayoutParameterName": "WidgetGroupTitlesFontSize",
            "LayoutParameterValueID": 606
        },
        {
            "JPath": "$MinRefreshInterval",
            "Value": "1000",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 21,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "MinRefreshInterval",
            "LayoutParameterValueID": 607
        },
        {
            "JPath": "$RefreshRealTimeDataDelay",
            "Value": "30",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 22,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "RefreshRealTimeDataDelay",
            "LayoutParameterValueID": 608
        },
        {
            "JPath": "$ReportInterval",
            "Value": "180",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 23,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "ReportInterval",
            "LayoutParameterValueID": 609
        },
        {
            "JPath": "$ReportSwitching",
            "Value": "0",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 24,
            "ParameterTypeName": "Boolean",
            "LayoutParameterName": "ReportSwitching",
            "LayoutParameterValueID": 610
        },
        {
            "JPath": "$ReportRefresh",
            "Value": "0",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 25,
            "ParameterTypeName": "Boolean",
            "LayoutParameterName": "ReportRefresh",
            "LayoutParameterValueID": 611
        },
        {
            "JPath": "$ColorPrimary",
            "Value": "#3280C1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 26,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorPrimary",
            "LayoutParameterValueID": 612
        },
        {
            "JPath": "$ColorBackground",
            "Value": "#FFFFFF",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 27,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorBackground",
            "LayoutParameterValueID": 613
        },
        {
            "JPath": "$ColorFrames",
            "Value": "#edf2f7",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 28,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorFrames",
            "LayoutParameterValueID": 614
        },
        {
            "JPath": "$ColorWidgetGroupBackground",
            "Value": "#edf2f7",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 29,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetGroupBackground",
            "LayoutParameterValueID": 615
        },
        {
            "JPath": "$ColorWidgetGroupFrames",
            "Value": "#edf2f7",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 30,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetGroupFrames",
            "LayoutParameterValueID": 616
        },
        {
            "JPath": "$ColorWidgetGroupTitles",
            "Value": "#000000",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 31,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetGroupTitles",
            "LayoutParameterValueID": 617
        },
        {
            "JPath": "$DashboardLogo",
            "Value": "",
            "IsText": 1,
            "ValueText": "data:image/jpeg;base64,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",
            "LayoutParameterID": 32,
            "ParameterTypeName": "DashboardLogo",
            "LayoutParameterName": "DashboardLogo",
            "LayoutParameterValueID": 86
        },
        {
            "JPath": "$ActoveCallWarning",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 33,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "ActiveCallWarning",
            "LayoutParameterValueID": 6770
        },
        {
            "JPath": "$ActiveCallLimit",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 34,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "ActiveCallLimit",
            "LayoutParameterValueID": 6767
        },
        {
            "JPath": "$ActiveCallWarningColor",
            "Value": "",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 35,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ActiveCallWarningColor",
            "LayoutParameterValueID": 6782
        },
        {
            "JPath": "$ActiveCallLimitColor",
            "Value": "",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 36,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ActiveCallLimitColor",
            "LayoutParameterValueID": 6779
        },
        {
            "JPath": "$HoldTimeWarning",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 37,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "HoldTimeWarning",
            "LayoutParameterValueID": 7350
        },
        {
            "JPath": "$HoldTimeLimit",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 38,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "HoldTimeLimit",
            "LayoutParameterValueID": 6761
        },
        {
            "JPath": "$HoldTimeWarningColor",
            "Value": "",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 39,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "HoldTimeWarningColor",
            "LayoutParameterValueID": 6776
        },
        {
            "JPath": "$HoldTimeLimitColor",
            "Value": "",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 40,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "HoldTimeLimitColor",
            "LayoutParameterValueID": 6773
        },
        {
            "JPath": "$WidgetTableContentFontSize",
            "Value": "16",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 41,
            "ParameterTypeName": "Number",
            "LayoutParameterName": "WidgetTableContentFontSize",
            "LayoutParameterValueID": 1120571
        },
        {
            "JPath": "$LoginStatusWarningColor",
            "Value": "#FAB11E",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 42,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "LoginStatusWarningColor",
            "LayoutParameterValueID": 1122806
        },
        {
            "JPath": "$LoginStatusLimitColor",
            "Value": "#FF3636",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 43,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "LoginStatusLimitColor",
            "LayoutParameterValueID": 1122809
        },
        {
            "JPath": "$InCallColor",
            "Value": "#5EB300",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 44,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "InCallColor",
            "LayoutParameterValueID": 1123385
        },
        {
            "JPath": "$OnHoldColor",
            "Value": "#E53E3E",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 45,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "OnHoldColor",
            "LayoutParameterValueID": 1123388
        },
        {
            "JPath": "$.MainBgColor",
            "Value": "#FFFFFF",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 46,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "MainBgColor",
            "LayoutParameterValueID": 1124812
        },
        {
            "JPath": "$.SecondaryBgColor",
            "Value": "#FFFFFF",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 47,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "SecondaryBgColor",
            "LayoutParameterValueID": 1124788
        },
        {
            "JPath": "$.ItemsMainColor",
            "Value": "#f5f7fa",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 48,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ItemsMainColor",
            "LayoutParameterValueID": 1124785
        },
        {
            "JPath": "$.ItemsSecondaryColor",
            "Value": "#f5f7fa",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 49,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ItemsSecondaryColor",
            "LayoutParameterValueID": 1124809
        },
        {
            "JPath": "$.CardsBgColor",
            "Value": "#f5f7fa",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 50,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "CardsBgColor",
            "LayoutParameterValueID": 1124797
        },
        {
            "JPath": "$.MainTextColor",
            "Value": "#000000",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 51,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "MainTextColor",
            "LayoutParameterValueID": 1124794
        },
        {
            "JPath": "$.ColorWidgetHeaderText",
            "Value": "#899398",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 52,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetHeaderText",
            "LayoutParameterValueID": 1124791
        },
        {
            "JPath": "$.ColorWidgetBackground",
            "Value": "#f7fafc",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 53,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetBackground",
            "LayoutParameterValueID": 1124806
        },
        {
            "JPath": "$.ColorTableHeaderBg",
            "Value": "#FFFFFF",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 54,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorTableHeaderBg",
            "LayoutParameterValueID": 1124800
        },
        {
            "JPath": "$.ColorTableContentText",
            "Value": "#000000",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 55,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorTableContentText",
            "LayoutParameterValueID": 1124803
        },{
            "IsText": 0,
            "JPath": "$.SoundWarning",
            "LayoutParameterID": 57,
            "LayoutParameterName": "SoundWarning",
            "LayoutParameterValueID": 1128998,
            "ParameterTypeName": "SingleSoundSelector",
            "Value": "default-warning",
            "ValueText": ""
        },{
            "IsText": 0,
            "JPath": "$.SoundError",
            "LayoutParameterID": 58,
            "LayoutParameterName": "SoundError",
            "LayoutParameterValueID": 1129001,
            "ParameterTypeName": "SingleSoundSelector",
            "Value": "default-error",
            "ValueText": ""
        }
    ]
})

export const extensionThresholdKeys = [
    'ActiveCallWarningColor',
    'ActiveCallLimitColor',
    'HoldTimeWarningColor',
    'HoldTimeLimitColor',
    'ActiveCallWarning',
    'ActiveCallLimit',
    'HoldTimeWarning',
    'HoldTimeLimit',
]

export const defaultExtensionThresholdConfig = {
    'ActiveCallWarningColor': 'green',
    'ActiveCallLimitColor': 'red',
    'HoldTimeWarningColor': 'green',
    'HoldTimeLimitColor': 'red',
    'ActiveCallWarning': 1,
    'ActiveCallLimit': 1,
    'HoldTimeWarning': 1,
    'HoldTimeLimit': 1,
}
